import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <header className="mb-6">
        <h1 className="text-4xl font-bold text-blue-700">Welcome to Continuous Audit Monitoring Demo</h1>
      </header>
      <nav className="mb-8">
        <Link 
          to="/departments" 
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          Go to Departments
        </Link>
      </nav>
      <section className="max-w-md text-center">
        <p className="text-gray-700">
          This dashboard is designed for our hypothetical company, <strong>Global Fashion & Retail Inc.</strong>, a $100 million revenue enterprise in the fashion and retail industry with offices worldwide.
          Our continuous audit monitoring system ensures that internal controls are working effectively across all departments.
          Select a department to review processes and detailed fraud indicators.
        </p>
      </section>
    </div>
  );
};

export default Dashboard;
